import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Loading from '../loading/Loading';

const SliderEnableModal = ({ show, handleClose, sliderOrder, isSubmitting, setIsSubmitting }) => {
  const [sliderStatus, setSliderStatus] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (show) {
      setIsLoading(true);
      axios.get('https://us-central1-inprojuy-f1173.cloudfunctions.net/app/slider-enable')
        .then(response => {
          // El endpoint devuelve un objeto { slider: boolean, ... }
          setSliderStatus(response.data);
        })
        .catch(error => {
          console.error('Error fetching slider status:', error);
          setSliderStatus({});
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [show]);

  const handleSwitchChange = (sliderName) => {
    setSliderStatus(prevStatus => ({
      ...prevStatus,
      [sliderName]: !prevStatus[sliderName]
    }));
  };

  const handleSave = () => {
    setIsSubmitting(true);
    // Convertir el objeto a array de { Slider, enable }
    const payload = Object.keys(sliderStatus).map(sliderName => ({
      Slider: sliderName,
      enable: sliderStatus[sliderName]
    }));
    axios.put('https://us-central1-inprojuy-f1173.cloudfunctions.net/app/slider-enable', payload)
      .then(() => {
        alert('Configuración guardada correctamente.');
        handleClose();
      })
      .catch(error => {
        console.error('Error al guardar la configuración:', error);
        alert('Error al guardar la configuración.');
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  if (!show) {
    return null;
  }

  return (
    <div className="modal" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Habilitar/Deshabilitar Sliders</h5>
            <button type="button" className="btn-close" onClick={handleClose}></button>
          </div>
          <div className="modal-body">
            {isSubmitting ? (
              <Loading />
            ) : (
              <ul className="list-group">
                {Object.keys(sliderStatus).map(sliderKey => (
                  <li key={sliderKey} className="list-group-item d-flex justify-content-between align-items-center">
                    {sliderKey.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id={`switch-${sliderKey}`}
                        checked={sliderStatus[sliderKey] || false}
                        onChange={() => handleSwitchChange(sliderKey)}
                      />
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={handleClose}>Cerrar</button>
            <button type="button" className="btn btn-primary" onClick={handleSave} disabled={isSubmitting}>Guardar Cambios</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SliderEnableModal;
